import RGL, { WidthProvider } from 'react-grid-layout';
import styled, { css } from 'styled-components';

const ReactGridLayout = WidthProvider(RGL);
export const LayoutWrapper = styled(ReactGridLayout)``;
export const Box = styled.div`
	border-radius: 8px;
	/* overflow: hidden; */
	overflow: visible;
	padding: 0rem 0rem 0rem 0;
	background-color: #ffffff;
	.child {
		font-size: 24px;
		text-align: center;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		display: flex;
		flex-direction: column;
		height: 100%;
		padding: 1rem 0.5rem;
	}
	.Title {
		height: auto;
		font-size: 14px;
		width: 100%;
		text-align: left;
		margin-bottom: 11px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 9px;
		/* border-bottom: 1px solid #8b8b8b6f; */
	}
	.Inner-Child {
		/* border: 1px solid red; */
		height: 100%;
		padding-bottom: 30px;
		& > div:first-of-type {
			height: 100% !important;
			/* padding: 16px !important; */
		}
	}
`;

export const DashboardWrapper = styled.div`
	/* border: 1px solid red; */
	padding: 0.2rem;
	position: relative;
	height: auto;
`;

export const CustomModal = styled.div`
	/* padding: 1rem; */
	${({ open }) => {
		switch (open) {
			case true:
				return css`
					display: block;
				`;

			default:
				return css`
					display: none;
				`;
		}
	}}
	border: 1px solid red;
	position: absolute;
	background-color: #ffffff;
	width: 100%;
	z-index: 99;
	top: 0;
	left: 0;
	height: 100%;
`;

export const CustomModalHeader = styled.div`
	background-color: #cecece;
	padding: 0.425rem;
`;

export const CardContentWrap = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 91%;
	cursor: pointer;
	border-radius: 8px;
	${({ theme }) => {
		switch (theme) {
			case 'successColor':
				return css`
					background-color: #deffcd;
					color: #369b00;
					& h2 {
						color: #369b00;
					}
				`;
			case 'Warning':
				return css`
					background-color: #fff0d1;
					color: #e69b00;
					& h2 {
						color: #e69b00;
					}
				`;
			case 'infoColor':
				return css`
					background-color: #dceeff;
					color: #2095ff;
					& h2 {
						color: #2095ff;
					}
				`;

			default:
				return css`
					background-color: #ececec;
					color: #676767;
					& h2 {
						color: #676767;
					}
				`;
		}
	}}
	h2 {
		font-size: 25px;
		font-weight: 600;
	}
	p {
		/* font-size: 0.8vw; */
		font-size: clamp(8px, 0.9vw, 20px);
	}
`;

export const CardV2Wrapper = styled.div`
	background-color: ${({ cardBgColor }) => cardBgColor || '#ffffff'};
	border: 2px solid #e0e0e0;
	border-radius: 8px;
	padding: 15px 0px 10px 15px;
	cursor: pointer;
	transition: all 0.3s ease;
	box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);
	display: flex;
	align-items: center;
	gap: 16px;
	height: 100%;
	position: relative;

	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		transform: translateY(-2px);
		border-color: ${({ iconBgColor }) => iconBgColor || '#2095ff'};
	}

	.dropdown-container {
		position: absolute;
		top: 20px;
		right: 20px;
		z-index: 10;
	}

	.icon-container {
		flex-shrink: 0;
		width: 48px;
		height: 48px;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: ${({ iconBgColor }) => iconBgColor || '#f0f0f0'};
		i {
			color: ${({ iconColor }) => iconColor || '#2095ff'};
			font-size: 24px;
		}
	}

	.content-wrapper {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 0px;
	}

	.title {
		font-size: 14px;
		font-weight: 500;
		color: #333333;
		margin: 0;
		padding:0;
		paddingBottom:5px;
		line-height: 1.4;
	}

	.value-wrapper {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-top: 0px;
	}

	.arrow-icon {
		color: #2095ff;
		font-size: 14px;
		opacity: 0.7;
	}

	.value {
		font-size: 21px;
		font-weight: 700;
		color: #333333;
		margin: 0;
		line-height: 1.2;
	}

	.description {
		font-size: 12px;
		color: #666666;
		margin: 0;
		line-height: 1.4;
	}
`;